<fieldset>
    <legend>
        DescriptionReduite
    </legend>
    <fieldset>
        <legend>
            lieuExecutionLivraison
        </legend>
        <app-type-lieu [uid]="getUid()+'_lieuExecutionLivraison'" [parentForm]="parentForm"
            [lieuExecution]="descriptionReduite.lieuExecutionLivraison"></app-type-lieu>
    </fieldset>

    <fieldset>
        <legend>
            lieuExecution
        </legend>
        <app-type-lieu [uid]="getUid()+'_lieuExecution'" [parentForm]="parentForm"
            [lieuExecution]="descriptionReduite.lieuExecutionLivraison"></app-type-lieu>
    </fieldset>

    <fieldset>
        <legend>
            lieuLivraisonlieuLivraison
        </legend>
        <app-type-lieu [uid]="getUid()+'_lieuLivraison'" [parentForm]="parentForm"
            [lieuExecution]="descriptionReduite.lieuExecutionLivraison"></app-type-lieu>
    </fieldset>
    <!---->

    <fieldset>
        <legend>
            cPV
        </legend>
        <app-type-objCPV [uid]="getUid()" [parentForm]="parentForm" [cpv]="descriptionReduite.cpv"></app-type-objCPV>
    </fieldset>

    <!---->

    <app-form-input [parentForm]="parentForm" [value]="descriptionReduite.objet"
        [label]="'objet'" [type]="'text'" [rule]="''" [name]="getUid()+'_SepAtt_objet'">
    </app-form-input>

    <!---->

    <app-form-input [parentForm]="parentForm" [value]="descriptionReduite.marcheServices"
         [label]="'marcheServices'" [type]="'text'" [rule]="''"
        [name]="getUid()+'_SepAtt_marcheServices'">
    </app-form-input>

    <!---->

    <fieldset>
        <legend>
            marcheTravaux
        </legend>
        <app-type-travaux [uid]="getUid()" [parentForm]="parentForm" [marcheTravaux]="descriptionReduite.marcheTravaux">
        </app-type-travaux>
    </fieldset>

    <!---->

    <fieldset>
        <legend>
            marcheFournitures
        </legend>
        <app-type-fournitures [uid]="getUid()" [parentForm]="parentForm"
            [marcheFournitures]="descriptionReduite.marcheFournitures"></app-type-fournitures>
    </fieldset>
</fieldset>
